import { useEffect } from "react";

export function usePreventZoom(scrollCheck = true, keyboardCheck = true) {
  useEffect(() => {
    function handleKeyDown(ev: any) {
      ///prevent ctrl and arrows
      if (
        keyboardCheck &&
        ev.ctrlKey &&
        (ev.keyCode == "61" ||
          ev.keyCode == "109" ||
          ev.keyCode == "107" ||
          ev.keyCode == "173" ||
          ev.keyCode == "187" ||
          ev.keyCode == "189")
      ) {
        ev.preventDefault();
      }
    }
    function handleWheel(ev: any) {
      if (scrollCheck && ev.ctrlKey) {
        ev.preventDefault();
      }
    }
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("wheel", handleWheel, { passive: false });
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("wheel", handleWheel);
    };
  }, [scrollCheck, keyboardCheck]);
}
